{
  "profile": {
    "enableProfileFeature": true,
    "enableEditProfile": false,
    "enableManageBusiness": true,
    "enableManageFleet": false,
    "isRefSessionComAvailable": true,
    "enableContentModeration": true
  },
  "events": {
    "enableEvents": true,
    "enableSearchInEvents": true,
    "enableCiamStatusInParticipantScreen": true,
    "enableDriftExercise": true,
    "enableSelfRegistration": true,
    "enableOffRoad": true,
    "enableUYSFeature": true,
    "enableVideoStatus": true,
    "enableEventLocation": false,
    "enableTermsAndCondition": true,
    "enableNewGpxFlow": true
  },
  "locations": {
    "enableCallerToggle": true,
    "enableLeftPanelView": true,
    "enableSatelliteView": true,
    "enableRecenter": true,
    "enableCreatedByYouFilter": false,
    "enableCircuitFeature": true,
    "enableCircuitEdit": true,
    "enableEmotionTourFeature": false,
    "enableRoundTrip": false,
    "enableCuratedTour": true,
    "enableEditPublishedTour": true,
    "enableAudioJsonUpload": true,
    "enableoffroadfeature": true,
    "enableOffRoadCreation": true,
    "enableLanguageSelection": true,
    "showLayoutUrl": true,
    "enableOffroadPark": true,
    "enableUploadStatus": false,
    "enableLastResults": false,
    "enableParticipantCount": false,
    "enableGoogleMaps": true
  },
  "contentModeration": {
    "enableSeachSort": false
  }
}
